var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.791,
    height: 24.749,
    viewBox: "0 0 24.791 24.749",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "eye",
    transform: "translate(0.791 4.327)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_280",
    "data-name": "Path 280",
    d: "M12,98.725c-4.585,0-8.744,2.509-11.812,6.584a.95.95,0,0,0,0,1.134c3.068,4.08,7.227,6.589,11.812,6.589s8.744-2.509,11.812-6.584a.95.95,0,0,0,0-1.134C20.744,101.234,16.585,98.725,12,98.725Zm.329,12.19a5.048,5.048,0,1,1,4.708-4.708A5.051,5.051,0,0,1,12.329,110.915Zm-.152-2.327a2.718,2.718,0,1,1,2.538-2.538A2.714,2.714,0,0,1,12.177,108.588Z",
    transform: "translate(0 -98.725)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2874",
    "data-name": "Rectangle 2874",
    width: 5,
    height: 30,
    rx: 2.5,
    transform: "translate(20.422 -4.327) rotate(45)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseView);
export default __webpack_public_path__ + "static/media/CloseView.3afd41dd72a61af5f7294672f3a3bc71.svg";
export { ForwardRef as ReactComponent };